import { isNull } from '@core/tools';
import { EOfflineReceiptStatus, offlineReceiptLabel, offlineReceiptSyle } from '../../types/common';
import { accountBookStatusLabel, accountBookStatusStyle, EAccountBookStatus, IYibaoDetail } from '../../types/yibao';
import { computed, ComputedRef, Ref } from 'vue';

type TagColor = 'success' | 'warning' | 'danger' | 'info' | 'primary';

interface IYibaoPaymentChannelStatus {
  /** 线下收款相关 */
  offlinePayStatus?: ComputedRef<{
    status?: EOfflineReceiptStatus;
    label?: string;
    icon?: string;
    iconColor?: string;
    description?: string;
    color?: TagColor;
    errorReason?: string;
  }>;
  largePaymentStatus?: ComputedRef<{
      status?: EAccountBookStatus;
      label?: string;
      icon?: string;
      iconColor?: string;
      description?: string;
      color?: TagColor;
      errorReason?: string;
    }>;
}

export function useYibaoPaymentChannelStatus<T extends IYibaoDetail>(info: Ref<T>, isAgent = false): IYibaoPaymentChannelStatus {
  const offlinePayStatus = computed(() => {
    let rs = {};

    const s = info.value?.offlineReceiptStatus;
    const failed = [EOfflineReceiptStatus.PRODUCT_MODIFY_REVIEW_BACK].includes(s);

    if (isNull(s) || s === EOfflineReceiptStatus.DRAFT) {
      return {
        status: s,
        label: offlineReceiptLabel[EOfflineReceiptStatus.DRAFT] as string,
        color: offlineReceiptSyle[EOfflineReceiptStatus.DRAFT] as TagColor,
        description: '您还没有线下收款，请申请',
        icon: 'material-symbols:error-outline-rounded',
        iconColor: '#BFBFBF',
      };
    }

    return {
      status: s,
      label: offlineReceiptLabel[s] as string,
      color: offlineReceiptSyle[s] as TagColor,
      icon: failed ? 'material-symbols:cancel-outline-rounded' : 'majesticons:clock-line',
      description: `线下收款${offlineReceiptLabel[s]}...`,
      iconColor: failed ? '#FF4948' : '#3194FA',
      errorReason: failed ? info.value?.offlineReceiptStatusRemark : undefined,
      ...rs,
    };
  });

  const largePaymentStatus = computed(() => {
    const s = info.value?.accountBooks?.[0]?.status;
  
    if (s === EAccountBookStatus.SUCCESS) {
      return {
        status: s,
        label: accountBookStatusLabel[EAccountBookStatus.SUCCESS],
        color: accountBookStatusStyle[EAccountBookStatus.SUCCESS] as TagColor,
      };
    }
  
    if (s === EAccountBookStatus.PROCESSING) {
      return {
        status: s,
        label: accountBookStatusLabel[EAccountBookStatus.PROCESSING],
        color: accountBookStatusStyle[EAccountBookStatus.PROCESSING] as TagColor,
        description: '大额支付资料已提交，正在审核中...',
        icon: 'majesticons:clock-line',
        iconColor: '#3194FA',
      };
    }
  
    if (s === EAccountBookStatus.FAIL) {
      return {
        status: s,
        label: accountBookStatusLabel[EAccountBookStatus.FAIL],
        color: accountBookStatusStyle[EAccountBookStatus.FAIL] as TagColor,
        description: '大额支付审核失败...',
        icon: 'material-symbols:cancel-outline-rounded',
        iconColor: '#FF4948',
      };
    }
  
    return {
      status: undefined,
      label: accountBookStatusLabel[EAccountBookStatus.NOTAPPLY],
      color: accountBookStatusStyle[EAccountBookStatus.NOTAPPLY] as TagColor,
      description: '您还没有大额支付，请申请',
      icon: 'material-symbols:error-outline-rounded',
      iconColor: '#BFBFBF',
    };
  });

  return {
    offlinePayStatus,
    largePaymentStatus, 
  };
}
